__turbopack_context__.v({
  "chip": "teaser-item-module-scss-module__8EqsZq__chip",
  "container": "teaser-item-module-scss-module__8EqsZq__container",
  "content": "teaser-item-module-scss-module__8EqsZq__content",
  "content-text-outside": "teaser-item-module-scss-module__8EqsZq__content-text-outside",
  "cta": "teaser-item-module-scss-module__8EqsZq__cta",
  "headline": "teaser-item-module-scss-module__8EqsZq__headline",
  "icon": "teaser-item-module-scss-module__8EqsZq__icon",
  "inline": "teaser-item-module-scss-module__8EqsZq__inline",
  "media": "teaser-item-module-scss-module__8EqsZq__media",
  "placeholder": "teaser-item-module-scss-module__8EqsZq__placeholder",
  "plain": "teaser-item-module-scss-module__8EqsZq__plain",
  "slim": "teaser-item-module-scss-module__8EqsZq__slim",
  "teaser": "teaser-item-module-scss-module__8EqsZq__teaser",
  "teaser-bg": "teaser-item-module-scss-module__8EqsZq__teaser-bg",
  "teaser-bg-Aqua": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Aqua",
  "teaser-bg-BackgroundGray": "teaser-item-module-scss-module__8EqsZq__teaser-bg-BackgroundGray",
  "teaser-bg-Berry": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Berry",
  "teaser-bg-Black": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Black",
  "teaser-bg-DarkAqua": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkAqua",
  "teaser-bg-DarkBerry": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkBerry",
  "teaser-bg-DarkGray": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkGray",
  "teaser-bg-DarkGreen": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkGreen",
  "teaser-bg-DarkMoss": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkMoss",
  "teaser-bg-DarkOrange": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkOrange",
  "teaser-bg-DarkRed": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkRed",
  "teaser-bg-DarkSmoke": "teaser-item-module-scss-module__8EqsZq__teaser-bg-DarkSmoke",
  "teaser-bg-FadedAqua": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedAqua",
  "teaser-bg-FadedBerry": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedBerry",
  "teaser-bg-FadedGray": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedGray",
  "teaser-bg-FadedGreen": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedGreen",
  "teaser-bg-FadedMoss": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedMoss",
  "teaser-bg-FadedRed": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedRed",
  "teaser-bg-FadedSmoke": "teaser-item-module-scss-module__8EqsZq__teaser-bg-FadedSmoke",
  "teaser-bg-Gray": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Gray",
  "teaser-bg-Green": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Green",
  "teaser-bg-HighlightMossModerate": "teaser-item-module-scss-module__8EqsZq__teaser-bg-HighlightMossModerate",
  "teaser-bg-HighlightMossStrong": "teaser-item-module-scss-module__8EqsZq__teaser-bg-HighlightMossStrong",
  "teaser-bg-HighlightMossSubtle": "teaser-item-module-scss-module__8EqsZq__teaser-bg-HighlightMossSubtle",
  "teaser-bg-LightAqua": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightAqua",
  "teaser-bg-LightBerry": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightBerry",
  "teaser-bg-LightGray": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightGray",
  "teaser-bg-LightGreen": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightGreen",
  "teaser-bg-LightMoss": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightMoss",
  "teaser-bg-LightRed": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightRed",
  "teaser-bg-LightSmoke": "teaser-item-module-scss-module__8EqsZq__teaser-bg-LightSmoke",
  "teaser-bg-Moss": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Moss",
  "teaser-bg-Orange": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Orange",
  "teaser-bg-Red": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Red",
  "teaser-bg-Smoke": "teaser-item-module-scss-module__8EqsZq__teaser-bg-Smoke",
  "teaser-bg-White": "teaser-item-module-scss-module__8EqsZq__teaser-bg-White",
  "text": "teaser-item-module-scss-module__8EqsZq__text",
  "text-cta": "teaser-item-module-scss-module__8EqsZq__text-cta",
  "text-cta-text": "teaser-item-module-scss-module__8EqsZq__text-cta-text",
  "thin": "teaser-item-module-scss-module__8EqsZq__thin",
});
